import AnswersView from '../components/answers-view/answers-view.tsx';

const AnswersViewPage = () => {
  return <AnswersView />;
};

export default AnswersViewPage;
